import en from './en/common';
import ru from './ru/common';
import tk from './tk/common';

export default {
  en: {
    common: en,
  },
  ru: {
    common: ru,
  },
  tk: {
    common: tk,
  },
};